import { render, staticRenderFns } from "./ListTitleAmount.vue?vue&type=template&id=61faa86b&"
import script from "./ListTitleAmount.vue?vue&type=script&lang=js&"
export * from "./ListTitleAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports